var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"data-width":"50","data-toggle":"touchspin","type":"text","data-step":_vm.dataStep,"data-decimals":_vm.dataDecimals,"data-bts-postfix":_vm.dataBtsPostfix},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }